import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./info.svg"; export default path + "#$"